import {
  useState
} from "react";

import API from "../../services/api";
import toast from "react-hot-toast";

function AdminChangePassword() {

  const [form,
    setForm] =
    useState({
      oldPassword:"",
      newPassword:""
    });

  const save =
    async (e) => {

      e.preventDefault();

      const token =
        localStorage.getItem(
          "adminToken"
        );

      await API.put(
        "/admin/change-password",
        form,
        {
          headers:{
            Authorization:
              `Bearer ${token}`
          }
        }
      );

      toast.success(
        "Password Changed"
      );
    };

  return (
    <div
      className="
      max-w-xl
      "
    >
      <h1
        className="
        text-3xl
        font-bold
        mb-6
        "
      >
        Change Password
      </h1>

      <form
        onSubmit={save}
        className="
        bg-[#111]
        p-6
        rounded-2xl
        space-y-4
        "
      >

        <input
          type="password"
          placeholder="Old Password"
          value={form.oldPassword}
          onChange={(e)=>
            setForm({
              ...form,
              oldPassword:
                e.target.value
            })
          }
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          "
        />

        <input
          type="password"
          placeholder="New Password"
          value={form.newPassword}
          onChange={(e)=>
            setForm({
              ...form,
              newPassword:
                e.target.value
            })
          }
          className="
          w-full
          p-3
          rounded-xl
          bg-black
          "
        />

        <button
          className="
          bg-yellow-500
          text-black
          px-6
          py-3
          rounded-xl
          "
        >
          Change Password
        </button>

      </form>
    </div>
  );
}

export default AdminChangePassword;